import { useState } from 'react';
import { Button } from '@nazka/nazka.mapframe.components';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import SharePopup from '@App/components/SharePopup/SharePopup';

import { trackEvent } from '@services/analytics.service';

import { encodeQuizResultsToParam } from '../quiz-component.utils';
import { questions } from '../quiz-component.constants';

import './quiz-result-component.styl'

function QuizResultComponent({ quizResults }) {
  const { t } = useTranslation()
  const [shareLink, setShareLink] = useState(false)

  const total = quizResults?.total ?? 10
  const correctCount = quizResults?.correctCount ?? 0
  const isCorrectByQuestionId = quizResults?.isCorrectByQuestionId ?? {}

  const questionIds = Array.from({ length: total }, (_, index) => index + 1)

  const handleShare = () => {
    const encoded = encodeQuizResultsToParam({
      total,
      correctCount,
      isCorrectByQuestionId,
    })
    if (!encoded) return

    const url = new URL(window.location.href)
    url.searchParams.set('quizResult', encoded)
    setShareLink(url.toString())
    trackEvent('quiz_result_shared');
  }
 
  return (
    <div className="quiz-result-component">
      <h2>
        {t('You scored')}
      </h2>

      <div className="quiz-result-component__result">
        <span>
          {correctCount}
          {' '}
          /
          {' '}
          {total}
        </span>
      </div>
      <div className="quiz-result-component__details-wrapper">
        <div className="quiz-result-component__status">
          {questionIds.map((questionId) => {
            const isCorrect = isCorrectByQuestionId[questionId] === true
            const isWrong = isCorrectByQuestionId[questionId] === false

            let dotClass = 'quiz-result-component__dot'
            if (isCorrect) dotClass = 'quiz-result-component__dot quiz-result-component__dot--correct'
            if (isWrong) dotClass = 'quiz-result-component__dot quiz-result-component__dot--wrong'

            return (
              <div key={questionId} className="quiz-result-component__status-item">
                <span className={dotClass} />
                <span>
                  {questionId}
                  .
                </span>
                <span className="quiz-result-component__question">{t(questions[questionId - 1]?.questionKey)}</span>
              </div>
            )
          })}
        </div>

      </div>
      
      <Button
        onClick={handleShare}
        css={{
          borderRadius: '8px',
          color: 'white',
          '&:hover': {
            color: 'white',
          },
          marginTop: '20px',
        }}
      >
        {t('Share result')}
      </Button>

      {shareLink && (
        <SharePopup
          qrCodeText={shareLink}
          onClose={() => setShareLink(false)}
        />
      )}
    </div>
  )
}

export default QuizResultComponent